'use strict';

/**
 * BD.Checkout: Handle checkout scripting
 */
var BD = window.BD = window.BD || {};
BD.Checkout = (function($) {
  var $ageCheckbox;
  var $orderForm;
  var $submitButtons;
  
  function updateCheckoutAvailability() {
    $submitButtons.toggleClass('disabled-but-clickable', !$ageCheckbox.is(':checked'));
    $submitButtons.toggleClass('disabled', !$ageCheckbox.is(':checked'));
  }
  
  function submitHandler(e) {
    if (!$ageCheckbox.is(':checked')) {
      $ageCheckbox.closest('.cartSummary__ageCheck').addClass('required');
      e.preventDefault();
      return false;
    }

    $orderForm.submit();
    return true;
  }
  
  function init() {
    $ageCheckbox = $('#chk_ageCheck');
    if (!$ageCheckbox.length) { return; }
    
    $orderForm = $('#frm_orderSummary');
    $submitButtons = $orderForm.find('button[type=submit]');

    $ageCheckbox.on('change', updateCheckoutAvailability);
    $orderForm.on('submit', submitHandler);
    $submitButtons.on('click', submitHandler);
    
    updateCheckoutAvailability();
  }
  
  function cartHasTour() {
    var tourLines = CartJS.cart.items.filter(line => 
      line.product_type.toLowerCase() == 'tour'
      || line.product_type.toLowerCase() == 'private tour'
      || line.handle == 'private-tour-deposit'
    );

    return tourLines.length != 0;
  }
  
  /**
   * @return boolean True if this product type is only valid on carts containing a tour.
   */
  function productTypeRequiresTour(productType) {
    productType = productType.toLowerCase();
    return productType == 'custom-pickup';
  }
  
  function removeTourRelatedLineItemsAndRedirect() {
    var variantRemovals = {};
    
    var removalLines = CartJS.cart.items.filter(line => productTypeRequiresTour(line.product_type));
    
    if (!removalLines.length) { return false; }
    
    removalLines.forEach(line => {
      variantRemovals[line.variant_id] = 0
    });
    
    $.post('/cart/update.js', { updates: variantRemovals }, function() {
      console.log("Removed tour-related items from cart with no tour.");
      window.location.reload(true);
    });

    return true;
  }
  
  function validateCartOrRedirect() {
    if (!cartHasTour()) {
      removeTourRelatedLineItemsAndRedirect();
    }
  }
  
  $(init);
  
  return {
    validateCartOrRedirect: validateCartOrRedirect
  };
})(jQuery);